import { response as sandboxResponse } from './sandbox/product-fetch-cache';
import { response as productionResponse } from './production/product-fetch-cache';

// Vite replaces import.meta.env.MODE at build time and tree-shakes the unused branch,
// so only the relevant cache is included in the final bundle.
export const response = import.meta.env.MODE === 'production'
  ? productionResponse
  : sandboxResponse;

export const fallbackProductHandle = response.product.handle;
